import React from 'react'

const AboutSection = ({h3, h1, p, imgsrc}) => {
    return (
        <div className='about_child'>

            {/* text */}
            <section className="about_text">
                <h3>{h3}</h3>
                <h1>{h1}</h1>
                <p>{p}</p>
            </section>

            {/* image */}
            <section className="about_img_main">
                <section className="about_img">
                    <img src={imgsrc} alt="image samples" />
                </section>
            </section>

        </div>
    )
}

export default AboutSection
